import { http, baseUrlOnboarding } from './_http';
import { logWebHrError } from "@/core/logger/log-wrapper";

export async function getTenantSettings(tenantId) {
  try {
    const result = await http.get(
      `${baseUrlOnboarding}/settings/tenants/${tenantId}`
    );

    if (!result || !result.data || !result.data.data) {
      return {};
    }

    return result.data.data;
  } catch (e) {
    logWebHrError({
      message: 'Failed to get tenant settings',
      source: 'tenant-settings',
      metadata: {
        tenantId,
      },
      error: e,
    });


    return {}; // TODO: remove this after fixing the backend svc

    // throw e;
  }
}

export default {
  getTenantSettings,
};
